// Eldhose John 20240226 @SumUps.com
import { globalFunctionSet } from './Global';

export default function Message(props) {
  globalFunctionSet('Message', (id, msg) => (
    (typeof props[id] === 'string') ? props[id] : msg
  ));
}
